"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _26P4PLHIcjs = require('./26P4PLHI.cjs');


var _KEDCOTT4cjs = require('./KEDCOTT4.cjs');


var _OJZKTJL7cjs = require('./OJZKTJL7.cjs');


var _VYZTFWCGcjs = require('./VYZTFWCG.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/dialog/dialog-backdrop.tsx
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
function DialogBackdrop({
  store,
  backdrop,
  alwaysVisible,
  hidden
}) {
  const ref = _react.useRef.call(void 0, null);
  const disclosure = _OJZKTJL7cjs.useDisclosureStore.call(void 0, { disclosure: store });
  const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
  _react.useEffect.call(void 0, () => {
    const backdrop2 = ref.current;
    const dialog = contentElement;
    if (!backdrop2) return;
    if (!dialog) return;
    backdrop2.style.zIndex = getComputedStyle(dialog).zIndex;
  }, [contentElement]);
  _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
    const id = contentElement == null ? void 0 : contentElement.id;
    if (!id) return;
    const backdrop2 = ref.current;
    if (!backdrop2) return;
    return _26P4PLHIcjs.markAncestor.call(void 0, backdrop2, id);
  }, [contentElement]);
  const props = _KEDCOTT4cjs.useDisclosureContent.call(void 0, {
    ref,
    store: disclosure,
    role: "presentation",
    "data-backdrop": (contentElement == null ? void 0 : contentElement.id) || "",
    alwaysVisible,
    hidden: hidden != null ? hidden : void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!backdrop) return null;
  if (_react.isValidElement.call(void 0, backdrop)) {
    return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _VYZTFWCGcjs.Role, { ...props, render: backdrop });
  }
  const Component = typeof backdrop !== "boolean" ? backdrop : "div";
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _VYZTFWCGcjs.Role, { ...props, render: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, Component, {}) });
}



exports.DialogBackdrop = DialogBackdrop;
